import HippaIconSection from '@Components/Common/HippaIconSection'
// import SvgAnimationBackground from '@Components/Common/SvgAnimationBackground'
import React from 'react'
import PrivacyPolicyCss from './PrivacyPolic.style'

function PrivacyPolicy() {
    return (
        <PrivacyPolicyCss>
            <div className="container return">
                <h1>Your DNA Privacy</h1>
                <p>
                    SNiP Nutrigenomics is committed to your privacy protection.
                </p>
                <p>
                    Your DNA is collected solely for the purposes of generating your DNA report(s) and
                    for the DNA-informed customization of your personalized nutritional supplement(s).
                </p>
                <p>
                    Your DNA is collected via a cheek swab, and sent directly to our HIPAA-compliant,
                    CLIA-certified, and CAP-accredited lab partner, whose security measures meet or
                    exceed industry standards. For added privacy, no name, email address, or other
                    identifying information is attached to your DNA sample. Rather, your swab is
                    connected to you only through a serial bar code and the indication you made as to
                    “male” or “female” during account registration. Cheek swabs are destroyed within 90
                    days.
                </p>
                <p>
                    Once the lab analyzes your DNA sample, raw data is delivered using advanced
                    encryption measures to our back-end partner, who generates your personalized
                    report(s), and makes them available to you through your password-protected
                    dashboard. Our platform utilizes state-of-the-art technology to ensure your account is
                    likewise safe and secure.
                </p>

                <p>
                    We do not store or sell your DNA data to third parties, including employers, health insurance
                    companies, or other entities.
                </p>
            </div>
            <HippaIconSection />
        </PrivacyPolicyCss>
    )
}

export default PrivacyPolicy;
